export const parseIntOrNull = (value: string) => {
  if (value.trim() === '') {
    return null
  }
  const parsed = Number(value)
  return Number.isNaN(parsed) ? null : parsed
}
